import { ILibraryItemResponse } from '../api/types';

export class LibraryItem implements ILibraryItemResponse {
  readonly id: number;
  readonly libraryId: number;
  readonly type: string;
  readonly title: string;
  readonly excerpt?: string;
  readonly published: boolean;
  readonly parentId?: number;
  readonly url: string;
  readonly createdAt: Date;
  readonly updatedAt: Date;

  constructor({ id, libraryId, type, title, excerpt, published, parentId, url, createdAt, updatedAt }: ILibraryItemResponse) {
    this.id = id;
    this.libraryId = libraryId;
    this.type = type;
    this.title = title;
    this.excerpt = excerpt;
    this.published = published;
    this.parentId = parentId;
    this.url = url;
    this.createdAt = new Date(createdAt);
    this.updatedAt = new Date(updatedAt);
  }
}
